import {
  TYPES,
  type ErrorClient,
  type ErrorHandler,
  SdkErrorHandler,
  SdkErrorClient,
} from '@bizzdesign/sdk-internal';
import {
  ApolloGraphqlAPIClient,
  type LowLevelClient,
  GenqlLowLevelClient,
  type GraphqlAPIClient,
  S3ClientImpl,
  type S3Client,
} from '@bizzdesign/sdk-lowlevel';
import {
  type KnowledgeGraphClientInterface,
  KnowledgeGraphClientImpl,
} from '@bizzdesign/sdk-knowledgegraph';

import { type ImportClient, ImportClientImpl } from '@bizzdesign/sdk-import';

import {
  type SearchClientInterface,
  SearchClientImpl,
} from '@bizzdesign/sdk-search';
import {
  type DeliverableClient,
  DeliverableClientImpl,
} from '@bizzdesign/sdk-deliverable';
import {
  type WorkflowClientInterface,
  WorkflowClientImpl,
} from '@bizzdesign/sdk-workflow';
import {
  type UserManagementClient,
  UserManagementClientImpl,
} from '@bizzdesign/sdk-user-management';
import { type ChatClient, ChatClientImpl } from '@bizzdesign/sdk-chat';
import { type SkillClient, SkillClientImpl } from '@bizzdesign/sdk-skill';

import { type Container } from 'inversify';
import {
  type PopulationClient,
  PopulationClientImpl,
} from '@bizzdesign/sdk-population';
import { type VersionClient, VersionClientImpl } from '@bizzdesign/sdk-version';

export function configureSharedDependencyInjection(container: Container): void {
  container
    .bind<GraphqlAPIClient>(TYPES.GraphqlAPIClient)
    .to(ApolloGraphqlAPIClient);
  // @ts-ignore 'Excessive stack depth comparing types' due to Genql typing complexity
  container.bind<LowLevelClient>(TYPES.LowLevelClient).to(GenqlLowLevelClient);
  container
    .bind<KnowledgeGraphClientInterface>(TYPES.KnowledgeGraphClient)
    .to(KnowledgeGraphClientImpl);
  container
    .bind<WorkflowClientInterface>(TYPES.WorkflowClient)
    .to(WorkflowClientImpl);
  container
    .bind<DeliverableClient>(TYPES.DeliverableClient)
    .to(DeliverableClientImpl);
  container
    .bind<PopulationClient>(TYPES.PopulationClient)
    .to(PopulationClientImpl);
  container
    .bind<SearchClientInterface>(TYPES.SearchClient)
    .to(SearchClientImpl);
  container.bind<ImportClient>(TYPES.ImportClient).to(ImportClientImpl);
  container.bind<VersionClient>(TYPES.VersionClient).to(VersionClientImpl);
  container
    .bind<UserManagementClient>(TYPES.UserManagementClient)
    .to(UserManagementClientImpl);
  container.bind<ChatClient>(TYPES.ChatClient).to(ChatClientImpl);
  container.bind<SkillClient>(TYPES.SkillClient).to(SkillClientImpl);
  container.bind<ErrorHandler>(TYPES.ErrorHandler).to(SdkErrorHandler);
  container.bind<ErrorClient>(TYPES.ErrorClient).to(SdkErrorClient);
  container.bind<S3Client>(TYPES.S3Client).to(S3ClientImpl);
}
